import type { BorrowerTypeEnum, TrusteeTypeEnum, TrustStructureEnum } from '@/helpers/const';
import type { Address } from '@/types';

export const BorrowerRole = {
  INDIVIDUAL: 'individual',
  DIRECTOR: 'director',
  TRUSTEE: 'trustee',
  PARTNER: 'partner',
} as const;

export type BorrowerRoleEnum = (typeof BorrowerRole)[keyof typeof BorrowerRole];

/** A married/defacto partner of a borrower applicant, as resolved by the backend. */
export interface BorrowerPartner {
  id: string;
  firstName?: string;
  lastName?: string;
  preferredName?: string;
}

export interface BorrowerApplicant {
  id: string;
  applicantId: string;
  role: BorrowerRoleEnum;
  /**
   * The applicant's married/defacto partner on this loan. Resolved by the backend from
   * relationship rows in both directions, so it is populated for both partners regardless of
   * which side owns the row and without depending on a primary applicant existing.
   */
  marriedOrDefactoTo?: BorrowerPartner;
}

export interface CompanyDetails {
  companyName?: string;
  hasRegisteredABN?: boolean;
  abnAcnNumber?: string;
  isTrading?: boolean;
  registeredAddress?: Address;
}

export interface TrustDetails {
  trustName?: string;
  trusteeType?: TrusteeTypeEnum;
  trustStructure?: TrustStructureEnum;
  // Company trustee details (when trusteeType === 'company')
  companyDetails?: CompanyDetails;
}

export interface BorrowerGroup {
  id: string;
  type: BorrowerTypeEnum;
  entityName?: string;
  abn?: string;
  acn?: string;
  companyDetails?: CompanyDetails;
  trustDetails?: TrustDetails;
  applicants?: BorrowerApplicant[];
}

export type BorrowerGroupEntry = { id: string } & Partial<BorrowerGroup>;
